import type { Colors, DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

const darkBitGoColors: Colors = {
  primary: {
    lighten: '#2155f0',
    default: '#0e3fd0',
    dim: 'rgba(14,63,208,0.4)',
    mute: 'rgba(14,63,208,0.1)',
  },
  gray: {
    main: '#0b0b10',
    '000': '#000',
    '010': '#070707',
    '020': '#19191d',
    '030': '#28282a',
    '040': '#363637',
    '050': '#3e3e3e',
    '060': '#484847',
    '070': '#595957',
    '080': '#85857f',
    '090': '#a7a79e',
    '100': '#ffe',
  },
  green: {
    lighten: '#45903c',
    default: '#346c2d',
    dim: 'rgba(52,108,45,0.4)',
    mute: 'rgba(52,108,45,0.1)',
  },
  red: {
    lighten: '#b91a35',
    default: '#8c1428',
    dim: 'rgba(140,20,40,0.4)',
    mute: 'rgba(140,20,40,0.1)',
  },
  yellow: {
    lighten: '#f1d58b',
    default: '#ebc55e',
    dim: 'rgba(235,197,94,0.4)',
    mute: 'rgba(235,197,94,0.1)',
  },
  orange: {
    lighten: '#f79c5b',
    default: '#f47f2b',
    dim: 'rgba(244,127,43,0.4)',
    mute: 'rgba(244,127,43,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: darkColors.purple,
  white: darkColors.white,
  black: {
    default: '#0b0b10',
    dim: 'rgba(11,11,16,0.4)',
    mute: 'rgba(11,11,16,0.1)',
  },
};

export const DarkBitGoTheme: DefaultTheme = mapDarkTheme(darkBitGoColors, {
  name: 'DarkBGo',
});
